'use client';
export { View } from 'react-native';
